import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.scss';

// i18n
import './i18n/i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';

import Application from './app/application';
import { App } from "antd";
import { QueryClient, QueryClientProvider } from "react-query";
import dictionaryStorage from "./storages/dictionary.storage";
import AuthCheck from "./forms/auth-check";
import { ReactQueryDevtools } from "react-query/devtools";

const queryClient = new QueryClient();

dictionaryStorage.loadDictionary();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App>
        <BrowserRouter>
          <QueryClientProvider
            client={queryClient}
          >
            <ReactQueryDevtools initialIsOpen={false} />
            <AuthCheck>
              <Application/>
            </AuthCheck>
          </QueryClientProvider>
        </BrowserRouter>
      </App>
    </I18nextProvider>
  </StrictMode>
);
